import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

import { ProductTypes } from '@/typeDefine/EntityType';



export default /*@__PURE__*/_defineComponent({
  __name: 'ProductTypeSubMenuItem',
  props: {
    items: {},
    collapse: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_Menu = _resolveComponent("Menu")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_ProductTypeSubMenuItem = _resolveComponent("ProductTypeSubMenuItem", true)!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
    return (_openBlock(), _createElementBlock(_Fragment, {
      key: item.id
    }, [
      (item.children && item.children.length > 0)
        ? (_openBlock(), _createBlock(_component_el_sub_menu, {
            key: 0,
            index: item.id + ''
          }, {
            title: _withCtx(() => [
              (_ctx.collapse)
                ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Menu)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createElementVNode("span", null, _toDisplayString(item.name), 1)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_ProductTypeSubMenuItem, {
                items: item.children,
                collapse: _ctx.collapse
              }, null, 8, ["items", "collapse"])
            ]),
            _: 2
          }, 1032, ["index"]))
        : (_openBlock(), _createBlock(_component_el_menu_item, {
            key: 1,
            index: item.id + ''
          }, {
            default: _withCtx(() => [
              (_ctx.collapse)
                ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Menu)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createElementVNode("span", null, _toDisplayString(item.name), 1)
            ]),
            _: 2
          }, 1032, ["index"]))
    ], 64))
  }), 128))
}
}

})